import api from './api';

// Admin API functions
export const checkAdminAccess = async () => {
  try {
    const response = await api.get('/admin/check', {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Failed to check admin access:', error);
    return { isAdmin: false };
  }
};

export const getTreeRatingStats = async () => {
  try {
    const response = await api.get('/admin/tree/stats', {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Failed to get tree rating stats:', error);
    throw error;
  }
};

export const getAllTreeNodes = async () => {
  try {
    const response = await api.get('/admin/tree/all', {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Failed to get all tree nodes:', error);
    throw error;
  }
};

export const createTreeNode = async (nodeData) => {
  try {
    const response = await api.post('/admin/tree/node', nodeData, {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Failed to create tree node:', error);
    throw error;
  }
};

export const updateTreeNode = async (id, nodeData) => {
  try {
    const response = await api.put(`/admin/tree/node/${id}`, nodeData, {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Failed to update tree node:', error);
    throw error;
  }
};

export const deleteTreeNode = async (id) => {
  try {
    const response = await api.delete(`/admin/tree/node/${id}`, {
      withCredentials: true
    });
    return response.status === 200;
  } catch (error) {
    console.error('Failed to delete tree node:', error);
    throw error;
  }
};

export const getUsersStats = async () => {
  try {
    const response = await api.get('/admin/users/stats', {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Failed to get users stats:', error);
    throw error;
  }
};

export const getTopRatedNodes = async (minRatings = 3) => {
  try {
    const response = await api.get('/admin/ratings/top', {
      params: { minRatings },
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Failed to get top rated nodes:', error);
    throw error;
  }
};

// Cards flagged for human review: thin evidence, a contradiction between sources, or - most
// often - a node title that promises more than the sources support. Admin only; the endpoint
// returns 403 to anyone else.
export const getFlaggedCards = async () => {
  try {
    const response = await api.get('/admin/flagged', {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Failed to load flagged cards:', error);
    return { count: 0, cards: [], error: error?.response?.data?.error || 'unreachable' };
  }
};

// Clears the review flag on one card, once the editorial call the flag was asking for has been
// made. Writes straight to the production database, so it takes effect without a redeploy.
// Throws on failure: the panel removes the row optimistically and needs to put it back.
export const resolveFlaggedCard = async (nodeId) => {
  const response = await api.delete(`/admin/flagged/${nodeId}`, {
    withCredentials: true
  });
  return response.data;
};
